import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { listarParceiros, listarParceirosBolsa, livresDoParceiro, pedirAula, minhasAulas, acaoMinhaAula, urlApi, pedirAvisoCapacitacao, contagemAvisoCapacitacao } from "../services/api";
import { idiomasDe } from "../services/idiomas";
import { quando, STATUS_AULA, EscolherHorario } from "../components/AulasComum";
import { abrirSala } from "../services/abrirSala";

// 🎓 CAPACITAÇÃO (17/10/2026): vitrine de professores e escolas APROVADOS, pedido de aula grátis e "Minhas aulas".
// 🌎 22/10/2026: no TOPO, o bloco "Idiomas" com as escolas com BOLSA ativas de idioma (/capacitacao/{slug}) e os
// professores de aula grátis de idioma; o resto vira "Outros cursos". Sem escola ativa, o bloco não existe e a
// página fica como era. ⚠️ Texto do curso nunca fala de vaga/emprego (regra do Nelson).
const iniciais = (nome) => (nome || "").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");
const ehDeIdioma = (p) => p.skills.some((s) => idiomasDe(s).length > 0);
// 22/10/2026: parceiros do cadastro novo (escola com bolsa OU professor com aula grátis) vêm de /capacitacao/bolsa.
const etiqueta = (e) => (e.tipo === "prof"
  ? `aula grátis${e.percentualBolsa ? ` · ${e.percentualBolsa}% de desconto` : ""}`
  : `${e.percentualBolsa}% de bolsa`);
function Marca({ e, cor = "bg-accent" }) {
  return (
    <div className={`w-10 h-10 shrink-0 rounded-lg ${cor} text-white font-bold flex items-center justify-center overflow-hidden`}>
      {e.logoUrl ? <img src={urlApi(e.logoUrl)} alt="" className="w-full h-full object-cover bg-white" /> : iniciais(e.nome)}
    </div>
  );
}

export default function CapacitacaoPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [skill, setSkill] = useState(new URLSearchParams(location.search).get("skill") || "");
  const [parceiros, setParceiros] = useState(null);
  const [aulas, setAulas] = useState([]);
  const [pedindo, setPedindo] = useState(null);   // parceiro escolhido para pedir aula
  const [erro, setErro] = useState("");
  const [aviso, setAviso] = useState("");
  const [bolsa, setBolsa] = useState([]);   // parceiros ATIVOS do cadastro novo/errata (escola com bolsa ou professor)
  const ehCandidato = user?.tipo === 0;

  const carregarAulas = () => { if (ehCandidato) minhasAulas().then(setAulas).catch(() => {}); };
  useEffect(() => { document.title = "Capacitação: aulas grátis e escolas parceiras · eaiRH"; carregarAulas(); }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { listarParceiros(skill.trim() || null).then(setParceiros).catch((e) => setErro(e.message)); }, [skill]);
  useEffect(() => {
    listarParceirosBolsa().then((l) => setBolsa(l || [])).catch(() => {});
  }, []);

  // Sem escola de idioma ativa, nada muda: o professor de idioma segue na lista de sempre.
  const escolasIdioma = bolsa.filter((e) => idiomasDe(e.curso).length > 0);
  const outrosBolsa = bolsa.filter((e) => idiomasDe(e.curso).length === 0);
  const temIdiomas = escolasIdioma.length > 0;
  const profsIdioma = temIdiomas ? (parceiros || []).filter((x) => ehDeIdioma(x.ficha)) : [];
  const outros = temIdiomas ? (parceiros || []).filter((x) => !ehDeIdioma(x.ficha)) : parceiros;
  // 🔔 26/10/2026: sem NENHUM parceiro ativo, a página mostra o "me avise" no lugar da vitrine vazia.
  const semParceiro = parceiros !== null && parceiros.length === 0 && bolsa.length === 0 && !skill.trim();

  const pedir = (p) => {
    if (!user) { navigate(`/entrar?redirect=${encodeURIComponent("/capacitacao")}&motivo=${encodeURIComponent("Entre para pedir sua aula grátis.")}`); return; }
    if (!ehCandidato) { setErro("Pedir aula é para contas de candidato."); return; }
    setPedindo(p);
  };

  const acao = async (a, nome, inicio) => {
    setErro(""); setAviso("");
    try { await acaoMinhaAula(a.id, nome, inicio); carregarAulas(); setAviso("Pronto!"); }
    catch (e) { setErro(e.message); }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-4xl mx-auto px-4 md:px-6 py-8">
        <h1 className="text-2xl md:text-3xl font-bold text-text">Capacitação</h1>
        <p className="text-gray-600 mt-1 text-sm">Desenvolva as skills que as vagas pedem. Cada professor oferece uma aula grátis, feita aqui mesmo no eaiRH, sem instalar nada.</p>
        {erro && <p className="mt-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{erro}</p>}
        {aviso && <p className="mt-3 rounded-xl bg-green-50 border border-green-200 text-green-800 text-sm px-3 py-2">{aviso}</p>}

        {semParceiro && <SemParceiro user={user} />}

        {temIdiomas && (
          <section className="mt-6 rounded-2xl p-5 text-white bg-gradient-to-br from-brand to-primary">
            <h2 className="text-xl font-extrabold">🌎 Idiomas</h2>
            <p className="text-sm opacity-90 mt-0.5">Escolas e professores parceiros com condição especial para quem tem cadastro no eaiRH.</p>
            <div className="mt-3 space-y-2">
              {escolasIdioma.map((e) => (
                <div key={e.slug} className="bg-white text-text rounded-xl p-3.5 flex gap-3 items-start">
                  <Marca e={e} />
                  <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-1.5">
                      <b>{e.nome}</b>
                      <span className="rounded-full bg-green-100 text-green-800 text-[11px] font-bold px-2 py-0.5">{etiqueta(e)}</span>
                    </div>
                    <div className="text-xs text-gray-500 mt-0.5">{[e.curso, e.duracao, e.frequencia].filter(Boolean).join(" · ")}</div>
                    <Link to={`/capacitacao/${e.slug}`} className="inline-block mt-2 bg-accent text-white font-bold rounded-lg px-4 py-1.5 text-sm">Ver condições</Link>
                  </div>
                </div>
              ))}
              {profsIdioma.map(({ ficha: p }) => (
                <div key={`prof-${p.id}`} className="bg-white text-text rounded-xl p-3.5 flex gap-3 items-start">
                  <div className="w-10 h-10 shrink-0 rounded-lg bg-brand text-white font-bold flex items-center justify-center">{iniciais(p.nomeExibicao)}</div>
                  <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-1.5">
                      <b>{p.nomeExibicao}</b>
                      <span className="rounded-full bg-sky-100 text-sky-900 text-[11px] font-bold px-2 py-0.5">aula grátis</span>
                    </div>
                    <div className="text-xs text-gray-500 mt-0.5">{[p.skills.join(", "), p.formato === "escola" ? "Escola" : "Professor(a)", p.cidade].filter(Boolean).join(" · ")}</div>
                    <button onClick={() => pedir(p)} className="inline-block mt-2 border border-brand text-brand font-semibold rounded-lg px-3 py-1.5 text-sm">Pedir aula grátis</button>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {ehCandidato && aulas.length > 0 && (
          <section className="mt-6 bg-white rounded-2xl shadow-sm p-5">
            <h2 className="font-bold text-text text-lg">Minhas aulas</h2>
            <ul className="mt-3 divide-y">
              {aulas.map((a) => (
                <li key={a.id} className="py-3 text-sm">
                  <div className="flex flex-wrap items-center gap-2">
                    <b>{a.com}</b>{a.skill && <span className="text-gray-500">· {a.skill}</span>}
                    <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${STATUS_AULA[a.status]?.cls || "bg-slate-100"}`}>{STATUS_AULA[a.status]?.txt || a.status}</span>
                  </div>
                  <div className="text-gray-600 mt-0.5">{quando(a.inicio)} · {a.duracaoMin} min</div>
                  {a.status === "sugerida" && a.sugeridoInicio && (
                    <div className="mt-2 rounded-xl bg-amber-50 border border-amber-200 p-2">
                      O professor sugeriu <b>{quando(a.sugeridoInicio)}</b>.
                      <button onClick={() => acao(a, "aceitar")} className="ml-2 bg-accent text-white font-bold rounded-lg px-3 py-1 text-xs">Aceitar</button>
                    </div>
                  )}
                  {a.status === "confirmada" && a.remarcacaoPor === "prof" && a.sugeridoInicio && (
                    <div className="mt-2 rounded-xl bg-amber-50 border border-amber-200 p-2">
                      O professor quer remarcar para <b>{quando(a.sugeridoInicio)}</b>{a.prazoResposta && <> (responda até {quando(a.prazoResposta)})</>}.
                      <button onClick={() => acao(a, "aceitar")} className="ml-2 bg-accent text-white font-bold rounded-lg px-3 py-1 text-xs">Aceitar</button>
                      <button onClick={() => acao(a, "recusar")} className="ml-1 bg-slate-100 font-bold rounded-lg px-3 py-1 text-xs">Manter o horário de antes</button>
                    </div>
                  )}
                  {a.status === "confirmada" && a.remarcacaoPor === "aluno" && a.sugeridoInicio && (
                    <div className="mt-2 text-xs text-gray-500">Você pediu para remarcar para {quando(a.sugeridoInicio)}. Aguardando o professor.</div>
                  )}
                  <div className="flex flex-wrap gap-2 mt-2">
                    {a.link && <a href={a.link} onClick={(ev) => abrirSala(ev, a.link)} className="bg-brand text-white font-bold rounded-lg px-3 py-1.5 text-xs">Entrar na sala</a>}
                    {a.status === "confirmada" && a.podeMexer && !a.remarcacaoPor && a.remarcacoesRestantes > 0 && (
                      <RemarcarAluno aula={a} onEscolher={(inicio) => acao(a, "remarcar", inicio)} />
                    )}
                    {a.podeMexer && <button onClick={() => window.confirm("Cancelar esta aula?") && acao(a, "cancelar")} className="text-red-600 text-xs font-semibold">Cancelar</button>}
                  </div>
                </li>
              ))}
            </ul>
            <p className="text-[11px] text-gray-400 mt-2">Remarcar e cancelar: até 12 horas antes. Cada aula pode ser remarcada até 2 vezes.</p>
          </section>
        )}

        {!semParceiro && <section className="mt-6">
          {(temIdiomas || outrosBolsa.length > 0) && <h2 className="font-bold text-text text-lg mb-2">Outros cursos</h2>}
          {outrosBolsa.length > 0 && (
            <div className="grid sm:grid-cols-2 gap-4 mb-4">
              {outrosBolsa.map((e) => (
                <div key={e.slug} className="bg-white rounded-2xl shadow-sm p-5 flex gap-3 items-start">
                  <Marca e={e} />
                  <div className="min-w-0">
                    <b className="text-text">{e.nome}</b>
                    <div><span className="rounded-full bg-green-100 text-green-800 text-[11px] font-bold px-2 py-0.5">{etiqueta(e)}</span></div>
                    <div className="text-xs text-gray-500 mt-1">{[e.curso, e.duracao, e.cidade].filter(Boolean).join(" · ")}</div>
                    <Link to={`/capacitacao/${e.slug}`} className="inline-block mt-2 bg-accent text-white font-bold rounded-lg px-4 py-1.5 text-sm">Ver condições</Link>
                  </div>
                </div>
              ))}
            </div>
          )}
          <input value={skill} onChange={(e) => setSkill(e.target.value)} placeholder="Qual skill você quer desenvolver? (ex.: Excel, Inglês)"
            className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm" />
          {/* 27/10: sem busca e com a Times no bloco Idiomas, a frase saía "Ainda não temos professor parceiro ." */}
          {outros && outros.length === 0 && profsIdioma.length === 0 && outrosBolsa.length === 0 && (skill.trim() || !temIdiomas) && (
            <p className="mt-4 text-sm text-gray-500">Ainda não temos professor parceiro {skill ? `de ${skill}` : ""}. Estamos convidando novos parceiros.</p>
          )}
          <div className="grid sm:grid-cols-2 gap-4 mt-4">
            {(outros || []).map(({ ficha: p, nota, avaliacoes }) => (
              <div key={p.id} className="bg-white rounded-2xl shadow-sm p-5 flex flex-col">
                <div className="font-bold text-text">{p.nomeExibicao}</div>
                <div className="text-xs text-amber-700 font-semibold">{avaliacoes > 0 ? `⭐ ${String(nota).replace(".", ",")} · ${avaliacoes} avaliação${avaliacoes > 1 ? "ões" : ""} de alunos` : "Novo no eaiRH"}</div>
                <div className="text-xs text-gray-500">{p.formato === "escola" ? "Escola" : "Professor(a)"}{p.cidade ? ` · ${p.cidade}` : ""} · aula grátis online</div>
                <div className="flex flex-wrap gap-1 mt-2">{p.skills.map((s) => <span key={s} className="rounded-full bg-sky-100 text-sky-900 text-xs font-semibold px-2 py-0.5">{s}</span>)}</div>
                {p.sobre && <p className="text-sm text-gray-600 mt-2 line-clamp-4">{p.sobre}</p>}
                {p.vantagem && <p className="text-xs text-green-800 bg-green-50 rounded-lg px-2 py-1 mt-2">🎁 {p.vantagem}</p>}
                <button onClick={() => pedir(p)} className="mt-auto pt-3 self-start"><span className="inline-block bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm">Pedir aula grátis</span></button>
              </div>
            ))}
          </div>
        </section>}
      </main>

      {pedindo && <PedirAula parceiro={pedindo} skillBusca={skill} onFechar={() => setPedindo(null)}
        onPedido={() => { setPedindo(null); setAviso("Pedido enviado! O professor tem até 24 horas para responder; você recebe o aviso por e-mail."); carregarAulas(); }} />}
    </div>
  );
}

// 🔔 26/10/2026 (mockup mokups/capacitacao-sem-parceiro.html, aprovado pelo Nelson): enquanto não há professor nem
// escola ativos, a página explica o que vem, guarda "o que você quer aprender" e aponta para o que já funciona.
const ASSUNTOS = ["Inglês para entrevista", "Excel", "Power BI", "Comunicação e oratória", "Espanhol", "Python"];
function SemParceiro({ user }) {
  const [marcados, setMarcados] = useState([]);
  const [outro, setOutro] = useState("");
  const [email, setEmail] = useState("");
  const [contagem, setContagem] = useState({});
  const [estado, setEstado] = useState("");   // "", "enviando", "ok"
  const [erro, setErro] = useState("");
  useEffect(() => {
    contagemAvisoCapacitacao().then((l) => setContagem(Object.fromEntries((l || []).map((x) => [x.skill.toLowerCase(), x.pedidos])))).catch(() => {});
  }, []);
  const alternar = (a) => setMarcados((m) => (m.includes(a) ? m.filter((x) => x !== a) : [...m, a]));
  const enviar = async () => {
    setErro("");
    const skills = [...marcados, ...outro.split(",").map((x) => x.trim()).filter(Boolean)];
    if (!skills.length) { setErro("Escolha pelo menos um assunto."); return; }
    if (!user && !email.trim()) { setErro("Informe o seu e-mail para receber o aviso."); return; }
    setEstado("enviando");
    try { await pedirAvisoCapacitacao(skills, user ? null : email.trim()); setEstado("ok"); }
    catch (e) { setErro(e.message); setEstado(""); }
  };
  return (
    <>
      <section className="mt-6 rounded-2xl p-5 text-white bg-gradient-to-br from-brand to-primary">
        <h2 className="text-xl font-extrabold">Estamos fechando os primeiros professores e escolas</h2>
        <p className="text-sm opacity-90 mt-1">Diga o que você quer aprender. Quando entrar um parceiro desse assunto, você é avisado primeiro, por e-mail.</p>
        <div className="grid sm:grid-cols-3 gap-2.5 mt-4 text-sm">
          <div className="rounded-xl bg-white/10 p-3"><b className="block">1. Aula grátis</b>Uma aula ao vivo com o professor, aqui no eaiRH, sem instalar nada.</div>
          <div className="rounded-xl bg-white/10 p-3"><b className="block">2. Bolsa</b>Desconto em escolas parceiras para quem tem cadastro no eaiRH.</div>
          <div className="rounded-xl bg-white/10 p-3"><b className="block">3. Do seu jeito</b>Você escolhe o horário. O professor confirma em até 24 horas.</div>
        </div>
      </section>

      <section className="mt-5 bg-white rounded-2xl shadow-sm p-5">
        <h2 className="font-bold text-text text-lg">O que você quer aprender?</h2>
        <p className="text-sm text-gray-600 mt-1">Escolha um ou mais. Os pedidos de cada assunto são o que levamos aos professores e escolas que estamos convidando.</p>
        {estado === "ok" ? (
          <p className="mt-4 rounded-xl bg-green-50 border border-green-200 text-green-800 text-sm px-3 py-2">✅ Pronto! Você recebe um e-mail quando entrar professor ou escola desses assuntos.</p>
        ) : (
          <>
            <div className="flex flex-wrap gap-2 mt-3">
              {ASSUNTOS.map((a) => {
                const n = contagem[a.toLowerCase()];
                const on = marcados.includes(a);
                return (
                  <button key={a} type="button" onClick={() => alternar(a)}
                    className={"rounded-full border-2 px-3.5 py-1.5 text-sm " + (on ? "border-brand bg-sky-50 text-brand font-bold" : "border-gray-200 text-text")}>
                    {a}{n ? <span className="text-gray-500 font-normal text-xs"> · {n}</span> : null}
                  </button>
                );
              })}
            </div>
            <input value={outro} onChange={(e) => setOutro(e.target.value)} maxLength={120}
              placeholder="Outro assunto? Escreva aqui (separe por vírgula)" className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm mt-3" />
            <div className="flex flex-wrap gap-2 items-center mt-3">
              {!user && <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Seu e-mail"
                className="border border-gray-300 rounded-xl px-3 py-2 text-sm flex-1 min-w-[220px]" />}
              <button onClick={enviar} disabled={estado === "enviando"} className="bg-accent text-white font-bold rounded-xl px-5 py-2 text-sm disabled:opacity-50">
                {estado === "enviando" ? "Enviando…" : "Me avise quando abrir"}
              </button>
            </div>
            {erro && <p className="text-red-600 text-sm mt-2">{erro}</p>}
          </>
        )}
      </section>

      <div className="grid sm:grid-cols-2 gap-4 mt-5">
        <section className="bg-white rounded-2xl shadow-sm p-5">
          <span className="inline-block bg-orange-50 text-orange-800 text-[11px] font-extrabold rounded-full px-2.5 py-0.5">DISPONÍVEL AGORA</span>
          <h3 className="font-bold text-text text-lg mt-2">Treine uma entrevista com retorno</h3>
          <p className="text-sm text-gray-600 mt-1">Uma conversa de 20 minutos com um recrutador, por vídeo. Depois, você recebe por e-mail 3 pontos fortes, 3 pontos de melhoria e os próximos passos.</p>
          <Link to="/simulacao?de=capacitacao" className="inline-block mt-3 bg-brand text-white font-bold rounded-xl px-4 py-2 text-sm">Quero treinar</Link>
        </section>
        <section className="bg-white rounded-2xl shadow-sm p-5">
          <span className="inline-block bg-orange-50 text-orange-800 text-[11px] font-extrabold rounded-full px-2.5 py-0.5">PARA PROFESSORES E ESCOLAS</span>
          <h3 className="font-bold text-text text-lg mt-2">Ensina algo que as vagas pedem?</h3>
          <p className="text-sm text-gray-600 mt-1">Ofereça uma aula grátis ou uma bolsa e apareça para quem está se preparando para o próximo emprego. O cadastro é grátis.</p>
          <Link to="/parceiro/cadastro?de=capacitacao" className="inline-block mt-3 border-2 border-brand text-brand font-bold rounded-xl px-4 py-1.5 text-sm">Quero ser parceiro</Link>
        </section>
      </div>
    </>
  );
}

function PedirAula({ parceiro, skillBusca, onFechar, onPedido }) {
  const [livres, setLivres] = useState(null);
  const [escolha, setEscolha] = useState(null);
  const [skill, setSkill] = useState(parceiro.skills.find((s) => s.toLowerCase() === (skillBusca || "").trim().toLowerCase()) || parceiro.skills[0] || "");
  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);
  useEffect(() => { livresDoParceiro(parceiro.id).then(setLivres).catch((e) => setErro(e.message)); }, [parceiro.id]);
  const enviar = async () => {
    setErro(""); setEnviando(true);
    try { await pedirAula({ parceiroId: parceiro.id, inicio: escolha, skill, mensagem }); onPedido(); }
    catch (e) { setErro(e.message); }
    setEnviando(false);
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onFechar}>
      <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full p-5 max-h-[90vh] overflow-y-auto text-sm" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-bold text-lg text-text">Aula grátis com {parceiro.nomeExibicao}</h3>
        {parceiro.skills.length > 1 && (
          <label className="block text-xs text-gray-600 mt-3">Skill
            <select value={skill} onChange={(e) => setSkill(e.target.value)} className="w-full border rounded-lg px-2 py-1.5 mt-1">
              {parceiro.skills.map((s) => <option key={s}>{s}</option>)}
            </select>
          </label>
        )}
        <div className="text-xs text-gray-600 mt-3">Escolha um horário</div>
        {livres === null ? <p className="text-gray-400 mt-1">Carregando…</p>
          : <EscolherHorario livres={livres} valor={escolha} onChange={setEscolha} vazio="Este professor não tem horário livre nos próximos 14 dias." />}
        <label className="block text-xs text-gray-600 mt-3">Recado para o professor (opcional)
          <textarea value={mensagem} onChange={(e) => setMensagem(e.target.value)} maxLength={500} rows={2} className="w-full border rounded-lg px-2 py-1.5 mt-1"
            placeholder="Ex.: sou iniciante e preciso de Excel para vagas administrativas" />
        </label>
        {erro && <p className="text-red-600 mt-2">{erro}</p>}
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onFechar} className="bg-slate-100 font-bold rounded-lg px-4 py-2">Voltar</button>
          <button disabled={!escolha || enviando} onClick={enviar} className="bg-accent text-white font-bold rounded-lg px-4 py-2 disabled:opacity-40">{enviando ? "Enviando…" : "Pedir aula"}</button>
        </div>
        <p className="text-[11px] text-gray-400 mt-2">O professor aprova ou sugere outro horário em até 24 horas. Confirmada, você recebe o convite na agenda e o link da sala.</p>
      </div>
    </div>
  );
}

function RemarcarAluno({ aula, onEscolher }) {
  const [aberto, setAberto] = useState(false);
  const [livres, setLivres] = useState(null);
  const [escolha, setEscolha] = useState(null);
  const abrir = () => { setAberto(true); livresDoParceiro(aula.parceiroId).then(setLivres).catch(() => setLivres([])); };
  if (!aula.parceiroId) return null;
  if (!aberto) return <button onClick={abrir} className="text-xs font-semibold text-primary">Remarcar</button>;
  return (
    <div className="w-full rounded-xl border p-2">
      {livres === null ? <p className="text-gray-400 text-xs">Carregando…</p> : <EscolherHorario livres={livres} valor={escolha} onChange={setEscolha} vazio="Sem outro horário livre." />}
      <div className="flex gap-2 mt-2">
        <button disabled={!escolha} onClick={() => { onEscolher(escolha); setAberto(false); }} className="bg-accent text-white font-bold rounded-lg px-3 py-1 text-xs disabled:opacity-40">Pedir remarcação</button>
        <button onClick={() => setAberto(false)} className="text-xs">Voltar</button>
      </div>
    </div>
  );
}
